import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import HeadingComponent from "../../../../common/components/heading/heading.component";
import DriverDetailsActiveRoutePlansComponent from "../details/active-route-plans/driver-details-active-route-plans.component";
import UserDriverPlanRouteParams from "../../common/routes/types/user-driver-plan-route-params";
import useDriverDetails from "../../../../common/services/driver/details/use-driver-details";
import useAbort from "../../../../common/hooks/use-abort";
import DriverDetailsParams from "../../../../common/services/driver/details/driver-details-params";

type DriverPlanProps = {};

const DriverPlanComponent: FC<DriverPlanProps> = () => {
  const { driverUuid } = useParams<UserDriverPlanRouteParams>();

  const driverDetails = useDriverDetails();
  const driverDetailsAbort = useAbort();

  useEffect(() => {
    if (!driverUuid) return;

    const params: DriverDetailsParams = {
      driverUuid: driverUuid,
    };

    driverDetails.load(params, driverDetailsAbort.signal);

    return driverDetailsAbort.revoke;
  }, [driverUuid]);

  if (!driverUuid || !driverDetails.data) return null;

  return (
    <>
      <HeadingComponent
        title={`${driverDetails.data.firstName} ${driverDetails.data.lastName}`}
      />
      <DriverDetailsActiveRoutePlansComponent
        driverUuid={driverUuid}
        isVisible={true}
        asCardComponent={true}
      />
    </>
  );
};

export default DriverPlanComponent;
